import { PureComponent } from 'react';

import { AvatarPropTypes } from '@atlaskit/avatar';
import { ProfilecardTriggerPosition } from '@atlaskit/profilecard';

import { Team, User } from 'src/components/types';
import {
  DeletedUserAvatar,
  UserAvatar as BaseUserAvatar,
} from 'src/components/user-profile';
import { userProfileClient } from 'src/utils/profile-client';

type Props = {
  profileCardPosition?: ProfilecardTriggerPosition;
  profileCardTrigger?: 'click' | 'hover';
  user: Team | User | null | undefined;
};

export class UserAvatar extends PureComponent<Props & AvatarPropTypes> {
  render() {
    const { profileCardPosition, profileCardTrigger, user, ...avatarProps } =
      this.props;

    if (!user) {
      return (
        <DeletedUserAvatar
          {...avatarProps}
          hasProfileCard
          profileCardPosition={profileCardPosition}
          profileCardTrigger={profileCardTrigger}
        />
      );
    }

    // Temporarily link to the profile page until workspace UI is enabled (and the profile page is gone)
    const href = undefined;

    // Temporarily disable profile cards for teams until we launch workspaces (PHAROS-465)
    if (user.type === 'team') {
      return (
        <BaseUserAvatar href={href || undefined} {...avatarProps} user={user} />
      );
    }

    return (
      <BaseUserAvatar
        href={href || undefined}
        {...avatarProps}
        profileCardPosition={profileCardPosition}
        profileCardTrigger={profileCardTrigger}
        profileClient={userProfileClient}
        profileUrl={href}
        user={user}
      />
    );
  }
}
